/* eslint-disable react/prop-types */
import { Icon, Upload, message } from 'antd';
import React from 'react';
import { StyledButton } from '../../styled';
import { parseData, isDataValid, transformData } from '../../logic';

const FileUpload = ({ fileList, setFileList, setApiPayload, setShowError }) => {
  const onFileSelect = ({ fileList: files, file }) => {
    if (!files.length) return setFileList(null);
    if (file.status === 'error') return message.error(`${file.name} file upload failed.`);
    return setFileList(files);
  };

  const handleFileUpload = async (file) => {
    try {
      const parsedFile = await parseData(file);
      const transformedData = transformData(parsedFile);
      const validData = isDataValid(transformedData);

      if (!validData) throw new Error('Invalid data');

      setApiPayload(transformedData);
    } catch (err) {
      console.log('err', err);
      setShowError(true);
    }
    return false;
  };

  return (
    /** Antd Upload component handles the display of the uploaded file name & deletion */
    <Upload
      fileList={fileList}
      multiple={false}
      accept=".csv"
      beforeUpload={handleFileUpload}
      onChange={onFileSelect}
      customRequest={() => true} // This is required to prevent the AntD Upload component from making an XHR request to the server
    >
      {!fileList && (
        <StyledButton type="primary">
          <Icon type="cloud-upload" /> Select document
        </StyledButton>
      )}
    </Upload>
  );
};

export default FileUpload;
